import { render, staticRenderFns } from "./Modal-item.vue?vue&type=template&id=6bb38cba&scoped=true&lang=pug"
import script from "./Modal-item.vue?vue&type=script&lang=js"
export * from "./Modal-item.vue?vue&type=script&lang=js"
import style0 from "./Modal-item.vue?vue&type=style&index=0&id=6bb38cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb38cba",
  null
  
)

export default component.exports